import 'twin.macro'

import RFQ from 'assets/icons/rfq.svg'
import CurrencyPairHeader from 'components/CurrencyPairHeader'
import IconButton from 'components/IconButton'
import Select from 'components/Select'
import { SelectData } from 'components/Select/Select'
import { Currency } from 'types/currency'
import { OrderType } from 'types/order-type'

import { Toolbar, Wrapper } from './Header.styles'

const orderTypeLabels: Record<OrderType, string> = {
  market: 'Market',
  limit: 'Limit',
  'stop-limit': 'Stop Limit',
  'steady-pace': 'Steady Pace',
}

const selectData: SelectData[] = Object.entries(orderTypeLabels).map(
  ([key, value]: [key: OrderType, value: string]) => ({
    label: value,
    value: key,
  }),
)

export interface HeaderProps {
  'data-test': string
  baseCurrency: Currency
  quotedCurrency: Currency
  orderStatus?: OrderType
  setBaseCurrency: (value: Currency) => void
  setQuotedCurrency: (value: Currency) => void
  onRFQClick?: () => void
  onOrderChange: (value: OrderType) => void
}

export const Header: React.FC<HeaderProps> = ({
  'data-test': dataTest = 'header',
  baseCurrency: defaultBaseCurrency,
  quotedCurrency: defaultQuotedCurrency,
  orderStatus,
  setBaseCurrency,
  setQuotedCurrency,
  onRFQClick,
  onOrderChange,
}) => {
  const handleOnOrderChange = (e: { value: SelectData }) => {
    const value = e.value.value as OrderType
    onOrderChange(value)
  }

  return (
    <Wrapper data-test={`${dataTest}.container`}>
      <CurrencyPairHeader
        data-test={`${dataTest}.currency-pair`}
        quotedCurrency={defaultQuotedCurrency}
        baseCurrency={defaultBaseCurrency}
        setBaseCurrency={setBaseCurrency}
        setQuotedCurrency={setQuotedCurrency}
      />
      <Toolbar>
        <IconButton
          data-test={`${dataTest}.rfq`}
          size="small"
          onClick={onRFQClick}
          aria-label="rfq"
        >
          <RFQ />
        </IconButton>
        <Select
          data-test={`${dataTest}.order-status`}
          size="small"
          data={selectData}
          value={orderStatus}
          onChange={handleOnOrderChange}
          hiddenStyle
        />
      </Toolbar>
    </Wrapper>
  )
}
